import {Component, OnDestroy, OnInit} from '@angular/core';
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {MatSnackBar} from "@angular/material/snack-bar";
import {CentreService} from "../../../../services/centre.service";
import {CentreOption} from "../../../../interfaces/Centres";
import {Observable, Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {FullChild} from "../../../../interfaces/FullChild";
import {DataSource} from "@angular/cdk/collections";
import {MatTableDataSource} from "@angular/material/table";

@Component({
  selector: 'app-discharge-reason-report',
  templateUrl: './discharge-reason-report.component.html',
  styleUrls: ['./discharge-reason-report.component.scss']
})
export class DischargeReasonReportComponent implements OnInit, OnDestroy {
  private _destroyed$ = new Subject<void>();
  start: Date | undefined
  end: Date | undefined
  centres: Observable<CentreOption[]>
  centreCode: string | undefined
  mData: FullChild[] = []
  mFilteredData: FullChild[] = []
  dataSource: MatTableDataSource<any>

  constructor(
    private readonly mFirestore: AngularFirestore,
    private readonly mCentreService: CentreService,
    private readonly mSnackBar: MatSnackBar
  ) {
    this.centres = this.mCentreService.getAllCentresOptions()
    this.dataSource = new MatTableDataSource()
  }

  search() {
    if (this.start && this.end && this.centreCode) {
      this.mFirestore.collection<FullChild>('ALChild', ref => ref.orderBy('childCode')
        // .where('centreCode', '==', this.centreCode)
      ).valueChanges({idField: 'id'})
        .pipe(takeUntil(this._destroyed$))
        .subscribe(res => {
          this.mData = res
          this.mData = this.mData.filter(x => x.admissionData.length >= 1)
          this.filterDataByDischarge(this.mData, this.start!!, this.end!!)

        })

    } else {
      this.mSnackBar.open('Please select date range', "", {
        duration: 2300,
        panelClass: 'error'
      })
    }
  }

  ngOnInit(): void {


  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  private filterDataByDischarge(mData: FullChild[], date: Date, date1: Date) {
    mData.forEach(child => {
      child.admissionData.forEach((it, i) => {
        if (i % 2 != 0 && it.dateOfDischarge!!.toDate() >= this.start!! && it.dateOfDischarge!!.toDate() <= this.end!! && it.centreCode == this.centreCode) {
          let lastindex = i - 1
          let obj = {
            Name: child.firstName + ' ' + child.lastName,
            Centre: it.centreName,
            dateOfDischarge: it.dateOfDischarge?.toDate(),
            reason: it.reason || "'",
            lastAdmissionDate: child.admissionData[lastindex].dateOfAdmission?.toDate()!! || ''
          }
          this.mFilteredData.push(child)
        }
      })

    })
    this.dataSource.data = this.mFilteredData
    console.log('CHILD ', this.mFilteredData)
  }
}
